import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Uses localStorage
// import storageSession from "redux-persist/lib/storage/session"; // If you prefer sessionStorage

import sessionReducer from "./auth/sessionReducer";
import auth from "./auth/authReducer";
import message from "./configuration/messageReducer";
import konfigurasiMenu from "./landingPage/konfigurasiMenuReducer";
import masterMenu from "./landingPage/masterMenuReducer";
import publisherId from "./configuration/publisherIdReducer";
import langReducer from "./landingPage/langReducer";
import manajemenWeb from "./landingPage/manajemenWebReducer";
import publisherBeritaIklan from "./landingPage/publisherBerta&IklanReducer";
import newsAds from "./news&ads";
import userState from "./userState";
import params from "./params";
import webManagement from "./webManagement";

// Combine all reducers
const combinedReducers = combineReducers({
  session: sessionReducer,
  params,
  auth,
  message,
  konfigurasiMenu,
  masterMenu,
  publisherId,
  langReducer,
  manajemenWeb,
  publisherBeritaIklan,
  newsAds,
  userState,
  webManagement,
});

// Configure redux-persist
const persistConfig = {
  key: "params",
  storage,
  whitelist: ["params"],
};

const rootReducer = persistReducer(persistConfig, combinedReducers);

export default rootReducer;
